module.exports = __webpack_public_path__ + "img/unico-sigorta.6304b3fa.jpg";